module.exports = require("react-truncate-markup");